import React, {useMemo} from 'react';
import styles from './index.module.scss';
import {useLocation, useParams} from 'react-router-dom';
import {APP_ROUTES} from "../../../Routes";
import Link from "../../CustomLink";
import {capitalize} from "../../../helpers/utils";

interface Props {
  baseCrumbs?: {path: string, name: string}[]
}

const Breadcrumbs = ({baseCrumbs}: Props) => {
  const location = useLocation();
  const dynamicRoutes = useParams();
  const routes = useMemo(() => {
    const actualRoute = Object.entries(dynamicRoutes).reduce((route, [key, value]) => {
      return route.replace(encodeURIComponent(value as string), `:${key}`)
    }, location.pathname);
    const usedRoutes = APP_ROUTES.filter(({path}) => actualRoute.includes(path as string))
    const crumbs = usedRoutes.map(({path, name}) => {
      const newPath = path?.replace(/:[A-Za-z0-9_-]+\/?/g, (match) => {
        return dynamicRoutes[match.replace(/[:/]/, '')] || ''
      }) || ''
      let renderName = dynamicRoutes[name] || name;
      return {path: newPath, name: capitalize(renderName, '-')}
    })
    return [...(baseCrumbs ? baseCrumbs : []), ...crumbs]
  }, [location, dynamicRoutes, baseCrumbs])
  return (
    <div className={styles.root}>
      {routes.map(({path, name}, i) => {
        if(i === routes.length - 1) return <p className={styles.text} key={i}>{name}</p>
        else return (
          <Link to={path === '/best-cars' ? '/cars' : path} key={i}>
            <p className={styles.text}>
              {name}
              <span className={styles.text__dash}>/</span>
            </p>
          </Link>
        )
      })}
    </div>
  )
}

export default React.memo(Breadcrumbs)
